import React from "react";
import { Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet";
import ProductBox from "../../components/product-box";
import shopBrow from "../../data/brow";

const ShopBrows = () => {
  return (
    <section className="brows ptb-30">
      <Helmet>
        <title>Brow Collection | Brow Bar by Reema</title>
      </Helmet>

      <div className="container">
        <h2>BROW COLLECTION</h2>
        <Row className="justify-content-center">
          <Col lg="12" sm="12">
            <div className="banner">
              <img
                src={require("../../assets/banners/brow-banner.jpg")}
                alt="Brow Collection | Brow Bar by Reema"
              />
            </div>
          </Col>
          <Col lg="6" sm="12">
            <div className="heading">
              <p>
                Reema's brow makeup collection is sure to transform your
                beautiful features. Our brow kits and tools come in various
                sizes and shades to perfectly enhance your true beauty.
              </p>
            </div>
          </Col>
        </Row>
        <Row className="products-list border-top-section ptb-30">
          <div className="container">
            <div className="product-stats">
              <p>We have total 68 products</p>
              {/* <Select
                options={options}
                classNamePrefix="select-control"
                placeholder="Sort by"
                name="sort-by"
                id="sort-by"
              /> */}
            </div>
            <Row>
              {shopBrow.map((product) => {
                return (
                  <Col lg="3" sm="12" key={product.id}>
                    <ProductBox
                      isOutOfStock={product.isOutOfStock}
                      productFrontImg={product.productFrontImg}
                      productBackImg={product.productBackImg}
                      productName={product.productName}
                      productPrice={product.productPrice}
                    />
                  </Col>
                );
              })}
            </Row>
          </div>
        </Row>
      </div>
    </section>
  );
};

export default ShopBrows;
